import React from 'react';
import IconButton from '../../icon-button';

const Menu = ({ glyph = 'floating-menu', ...props }) => (
  <div className="ws-ui-editor-header__menu">
    <IconButton {...props} glyph={glyph} />
  </div>
);

export default Menu;
